import { ActionType } from "../action-types/type";
import { Dispatch } from "redux";
import { GlobalAlertAction } from "../actions/alertActions";

export const setGlobalAlert = (
  message: string,
  alertType: "error" | "warn" | "info" | "success",
  details?: string[]
) => {
  return (dispatch: Dispatch<GlobalAlertAction>) => {
    dispatch({
      type: ActionType.SET_GLOBAL_ALERT,
      payload: { message, alertType, details },
    });
  };
};

export const clearGlobalAlert = () => {
  return (dispatch: Dispatch<GlobalAlertAction>) => {
    dispatch({
      type: ActionType.CLEAR_GLOBAL_ALERT,
    });
  };
}; 